import "../calculator-projection-presenter.js";
import "../calculator-user-layer-v4-presets.js";
import { registerCalculatorAssignmentConnections } from "./calculator-assignment-connections.js";
import { registerCalculatorSectionStack } from "./calculator-section-stack.js";
import { registerCalculatorEngine } from "./calculator-engine.js";
import { registerCalculatorLayerInspector } from "./calculator-layer-inspector.js";
import { registerCalculatorLayerInspectorHost } from "./calculator-layer-inspector-host.js";
registerCalculatorAssignmentConnections();
registerCalculatorSectionStack();
registerCalculatorEngine();
registerCalculatorLayerInspector();
registerCalculatorLayerInspectorHost();
